export const FormatBankAccountHelper = (
  bankAccount: string | undefined
): string | undefined => {
  const length = bankAccount?.length || 0;
  let parsedValue = "XXXXXXXXXXXXXX" + bankAccount?.slice(length - 4, length);
  parsedValue = parsedValue?.replace(/^([X\d]{3})([X\d])/g, "$1 $2");
  parsedValue = parsedValue?.replace(
    /^([X\d]{3}\s)([X\d]{3})([X\d])/g,
    "$1$2 $3"
  );
  parsedValue = parsedValue?.replace(
    /^([X\d]{3}\s)([X\d]{3}\s)([X\d]{11})([X\d])/g,
    "$1$2$3 $4"
  );
  return parsedValue;
};
